import { EcPrintDirective } from './ec-print.directive';
import { HasAccessDirective } from './has-access.directive';

export * from './ec-print.directive';
export * from './has-access.directive';

export const directive: any[] = [EcPrintDirective, HasAccessDirective];
